import React from 'react';
import { useTranslation } from 'react-i18next';
import FoxPortrait from '../illustrations/FoxPortrait.jsx';
import './ContactCard.css';

/**
 * Card for one contact person: a fox portrait, name, phone and email. A row without a value
 * yet keeps its place and shows a dash.
 * @param {Object} props
 * @param {{id: string, name: string, phone: string, email: string, fox?: Object}} props.contact
 *   Entry from CONTACTS; `fox` is passed to FoxPortrait
 * @returns {JSX.Element} Contact card
 */
function ContactCard({ contact }) {
  const { t } = useTranslation();
  const rows = [
    {
      label: t('about.phoneLabel'),
      value: contact.phone,
      href: `tel:${contact.phone.replace(/\s/g, '')}`,
    },
    { label: t('about.emailLabel'), value: contact.email, href: `mailto:${contact.email}` },
  ];

  return (
    <article className="contact-card">
      <span className="contact-card-avatar">
        <FoxPortrait {...contact.fox} />
      </span>
      <h3 className="contact-card-name">{contact.name}</h3>
      <dl className="contact-card-rows">
        {rows.map((row) => (
          <div key={row.label} className="contact-card-row">
            <dt>{row.label}</dt>
            <dd>{row.value ? <a href={row.href}>{row.value}</a> : '–'}</dd>
          </div>
        ))}
      </dl>
    </article>
  );
}

export default ContactCard;
